import React, { useCallback, useEffect, useRef, useState } from 'react'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import { Icon as MdiIcon } from '@mdi/react'
import { mdiMenuDown } from '@mdi/js'
import { SelectItem, SelectProps } from './types'
import './styles.scss'

const Select: React.FC <SelectProps> = ({ type, defaultValue, label, fieldName, setValue, setFieldValue, onChange, value, status, items }) => {

    const labelRef = useRef<HTMLDivElement>(null)
    const [open, setOpen] = useState(false)
    const [positions, setPositions] = useState<DOMRect>()

    const handleOpen = useCallback(() => {
        if(open) setOpen(false)
        else setOpen(true)
    }, [open])

    const handleClick = useCallback(({ value }: SelectItem) => {
        if(!!setValue) setValue(value)
        if(!!setFieldValue && fieldName) setFieldValue(fieldName, value)
        if(!!onChange) onChange()
        
        setOpen(false)
    }, [setValue, setFieldValue, onChange, fieldName])

    useEffect(() => {
        if(defaultValue){
            if(!!setValue) setValue(defaultValue.toString())
            if(!!setFieldValue && fieldName) setFieldValue(fieldName, defaultValue.toString())
        }
    }, [setValue, setFieldValue, fieldName, defaultValue])

    useEffect(() => {
        if(labelRef && labelRef.current) setPositions(labelRef.current.getBoundingClientRect())
    }, [items, open])

    return(

        <>
            <div className = "selectWrapper">
                {!!label && <span className = "selectTitleLabel">{label}</span> }
                <div ref = {labelRef} className = {`selectLabelContainer select-${type ?? 'default'}${status && type === 'outline' ? ` status ${status}` : ''}${open ? ' open' : ''}`} onClick = {handleOpen}>
                    <span className = "selectLabel">
                        {value !== undefined && value !== null ? (items.find(item => item.value === value) ? items.find(item => item.value === value)!.label : label ?? 'Selecionar') : label ?? 'Selecionar'}
                    </span>
                    <span className = {`selectIcon${open ? ' open' : ''}`}>
                        <MdiIcon path = {mdiMenuDown} size = "24px" />
                    </span>
                </div>
                {open && (
                    <ClickAwayListener onClickAway = {() => setOpen(false)}>
                        <ul 
                            className = {`selectItemsContainer scroll${open ? ' open' : ''}`} 
                            style = {{ width: positions?.width }}
                        >
                            {items.map((item, index) => 
                                <li key = {index} className = {`selectItem${item.value === value ? ' selected' : ''}`} onClick = {() => handleClick(item)}>{item.label}</li>
                            )}
                        </ul>
                    </ClickAwayListener>
                )}
            </div>
        </>

    )

}

export default Select